import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import {
  ShowRequiredField,
  CivilStatusList,
  GenderList,
  kPButton,
  CitizenshipList,
} from "../global";
import AdmissionContext from "../AdmissionContext";

class PersonalInformationView extends Component {
  static contextType = AdmissionContext;

  constructor(props) {
    super(props);
    this.state = {
      highschool: {description: 'Filipino'}
    };
  }

  textfieldValueChanged = (index, event) => {
    const { personalInformation } = this.context;
    personalInformation.required = false;

    if (index === 0) {
      //lastName
      personalInformation.lastName = event.target.value;
    } else if (index === 1) {
      //firstName
      personalInformation.firstName = event.target.value;
    } else if (index === 2) {
      //middleName
      personalInformation.middleName = event.target.value;
    } else if (index === 3) {
      //maidenName
      personalInformation.maidenName = event.target.value;
    } else if (index === 4) {
      //placeOfBirth
      personalInformation.placeOfBirth = event.target.value;
    } else if (index === 5) {
      //religion
      personalInformation.religion = event.target.value;
    } else if (index === 6) {
      //citizenship
      personalInformation.citizenship = event.target.value;
    }

    this.context.SetPersonalInformation(personalInformation);
  };

  genderValueChanged = (event, value) => {
    const { personalInformation } = this.context;
    personalInformation.required = false;
    personalInformation.gender = value;
    this.context.SetPersonalInformation(personalInformation);
  };

  // export const CivilStatusList = [
  //   { description: "Single" },
  //   { description: "Married" },
  //   { description: "Widowed" },
  //   { description: "Separated" },
  // ];

  civilStatusValueChanged = (event, value) => {
    const { personalInformation } = this.context;
    personalInformation.required = false;
    personalInformation.civilStatus = value;

    if (value.description === 'Single') {
      personalInformation.maidenName = "";
    }

    this.context.SetPersonalInformation(personalInformation);
  };

  citizenshipValueChanged = (event, value) => {
    const { personalInformation } = this.context;
    personalInformation.required = false;
    this.setState({
      citizenship: value,
    });

    console.log('personalInformation.citizenship 1')
    console.log(personalInformation.citizenship)
    console.log('personalInformation.citizenship 2')

    if(value == null){
      personalInformation.citizenship = "";
    } else {
      if (value.description === 'Filipino') {
        personalInformation.citizenship = "Filipino";        
      } else {
        personalInformation.citizenship = "";
      }
    }

    this.context.SetPersonalInformation(personalInformation);
  };

  dateOfBirthValueChanged = (value) => {
    const { personalInformation } = this.context;
    personalInformation.required = false;
    if (value === null) {
      personalInformation.dateofBirth = null;
    } else {
      personalInformation.dateofBirth = moment(value).format("MM/DD/YYYY");
    }

    this.context.SetPersonalInformation(personalInformation);
  };

  checkRequireFields = (index) => {
    const { personalInformation } = this.context;

    if (personalInformation.required) {
      if (index === 0) {
        if (personalInformation.lastName === "") {
          return ShowRequiredField("Last Name");
        }
      } else if (index === 1) {
        if (personalInformation.firstName === "") {
          return ShowRequiredField("First Name");
        }
      } else if (index === 2) {
        if (personalInformation.middleName === "") {
          return ShowRequiredField("Middle Name");
        }
      } else if (index === 3) {
        if (personalInformation.dateofBirth === "" || personalInformation.dateofBirth === null) {
          return ShowRequiredField("Date of Birth");
        } else {
          var currentYear = moment(new Date()).format('YYYY')
          var dateofBirthYear = moment(personalInformation.dateofBirth, 'MM/DD/YYYY').format('YYYY')

          if (dateofBirthYear >= currentYear) {
            return <Typography component="div">
              <Box fontSize={14} color="error.main" display="flex" pt={1}>
                Invalid Date of Birth
              </Box>
            </Typography>
          }
        }


      } else if (index === 4) {
        if (personalInformation.placeOfBirth === "") {
          return ShowRequiredField("Place of Birth");
        }
      } else if (index === 5) {
        if (personalInformation.gender === null) {
          return ShowRequiredField("Gender");
        }
      } else if (index === 6) {
        if (personalInformation.civilStatus === null) {
          return ShowRequiredField("Civil Status");
        }
      } else if (index === 7) {
        if (personalInformation.religion === "") {
          return ShowRequiredField("Religion");
        }
      } else if (index === 8) {
        if (personalInformation.citizenship === "") {
          return ShowRequiredField("Citizenship");
        }
      }
    }

    return null;
  };

  backButtonClicked = () => {
    this.context.btnBackClicked();
  };

  nextButtonClicked = () => {
    const { personalInformation } = this.context;

    if (
      personalInformation.lastName === "" ||
      personalInformation.firstName === "" ||
      personalInformation.middleName === "" ||
      personalInformation.dateofBirth === "" || personalInformation.dateofBirth === null ||
      personalInformation.placeOfBirth === "" ||
      personalInformation.gender === null ||
      personalInformation.civilStatus === null ||
      personalInformation.religion === "" ||
      personalInformation.citizenship === ""
    ) {
      personalInformation.required = true;
      this.context.SetPersonalInformation(personalInformation);
    } else {

      var currentYear = moment(new Date()).format('YYYY')
      var dateofBirthYear = moment(personalInformation.dateofBirth, 'MM/DD/YYYY').format('YYYY')

      if (dateofBirthYear >= currentYear) {
        personalInformation.required = true;
        this.context.SetPersonalInformation(personalInformation);
        return
      }

      this.context.btnNextClicked();
    }
  };

  render() {
    const { personalInformation } = this.context;
    return (
      <Box display="flex" justifyContent="center" pt={2}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
            <Card
              style={{
                border: 0,
                // minWidth: 500,
                // maxWidth: 600,
              }}
              variant="outlined"
            >
              <CardContent>
                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                  >
                    Personal Information
                  </Box>
                </Typography>

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtLastName"
                    label="Last Name"
                    variant="outlined"
                    value={personalInformation.lastName}
                    onChange={(e) => {
                      this.textfieldValueChanged(0, e);
                    }}
                  />
                </Box>

                {/* lastName */}
                {this.checkRequireFields(0)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtFirstName"
                    label="First Name"
                    variant="outlined"
                    value={personalInformation.firstName}
                    onChange={(e) => {
                      this.textfieldValueChanged(1, e);
                    }}
                  />
                </Box>

                {/* firstName */}
                {this.checkRequireFields(1)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtMiddleName"
                    label="Middle Name"
                    variant="outlined"
                    value={personalInformation.middleName}
                    onChange={(e) => {
                      this.textfieldValueChanged(2, e);
                    }}
                  />
                </Box>

                {/* middleName */}
                {this.checkRequireFields(2)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtMaidenName"
                    label="Maiden Name (for married female)"
                    variant="outlined"
                    value={personalInformation.maidenName}
                    onChange={(e) => {
                      this.textfieldValueChanged(3, e);
                    }}
                  />
                </Box>

                <Box pt={2}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      margin="normal"
                      id="dtpDateofBirth"
                      label="Date of Birth (MM/DD/YYYY)"
                      format="MM/dd/yyyy"
                      value={personalInformation.dateofBirth}
                      onChange={(e) => this.dateOfBirthValueChanged(e)}
                      inputVariant="outlined"
                      fullWidth={true}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Box>

                {/* dateofBirth */}
                {this.checkRequireFields(3)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtPlaceofBirth"
                    label="Place of Birth"
                    variant="outlined"
                    value={personalInformation.placeOfBirth}
                    onChange={(e) => {
                      this.textfieldValueChanged(4, e);
                    }}
                  />
                </Box>

                {/* placeOfBirth */}
                {this.checkRequireFields(4)}

                <Box pt={2}>
                  <Autocomplete
                    id="cboGender"
                    options={GenderList}
                    getOptionLabel={(item) => item.description}
                    fullWidth={true}
                    onChange={this.genderValueChanged}
                    value={personalInformation.gender}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Sex"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {/* gender */}
                {this.checkRequireFields(5)}

                <Box pt={2}>
                  <Autocomplete
                    id="cboCivilStatus"
                    options={CivilStatusList}
                    getOptionLabel={(item) => item.description}
                    fullWidth={true}
                    onChange={this.civilStatusValueChanged}
                    value={personalInformation.civilStatus}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Civil Status"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {/* civilStatus */}
                {this.checkRequireFields(6)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtReligion"
                    label="Religion"
                    variant="outlined"
                    value={personalInformation.religion}
                    onChange={(e) => {
                      this.textfieldValueChanged(5, e);
                    }}
                  />
                </Box>

                {/* religion */}
                {this.checkRequireFields(7)}

                {/* <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtCitizenship"
                    label="Citizenship"
                    variant="outlined"
                    value={personalInformation.citizenship}
                    onChange={(e) => {
                      this.textfieldValueChanged(6, e);
                    }}
                  />
                </Box> */}

                <Box pt={2}>
                  <Autocomplete
                    id="cboCitizenship"
                    options={CitizenshipList}
                    value={this.state.citizenship}
                    getOptionLabel={(item) => item.description}
                    fullWidth={true}
                    onChange={this.citizenshipValueChanged}
                    renderInput={(params) => (
                      <TextField {...params} label="Citizenship" variant="outlined" />
                    )}
                  />
                </Box>
                {this.showCitizenship()}

                {/* citizenship */}
                {this.checkRequireFields(8)}

                <Box
                  justifyContent="center"
                  display="flex"
                  pt={3}
                  fontSize={14}
                >
                  <Box width={200} justifyContent="flex-start">
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.backButtonClicked();
                      }}
                    >
                      Back
                    </Button>
                  </Box>

                  <Box width={200} minHeight={100} pl={2}>
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.nextButtonClicked();
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={1} sm={2} lg={3}></Grid>
        </Grid>
      </Box>
    );
  }

  showCitizenship = () => {
    const { personalInformation } = this.context;
    if(this.state.citizenship == null) return null;
    if(this.state.citizenship.description == "Others"){
      return (
        <div>
          <Box pt={2}>
            <TextField
              fullWidth={true}
              id="txtCitizenship"
              label="Citizenship"
              variant="outlined"
              value={personalInformation.citizenship}
              onChange={(e) => {
                this.textfieldValueChanged(6, e);
              }}
            />
          </Box>
  
        </div>
      )
    }
    
    return null
  }


}

export default PersonalInformationView;
